import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PromotionBanner = ({
  title,
  description,
  cta,
  dataSelenium
}) => {
  return /*#__PURE__*/_jsx(Alert, {
    "data-selenium": dataSelenium,
    type: "info",
    titleText: title,
    inlineSize: "100%",
    children: /*#__PURE__*/_jsxs(ButtonWrapper, {
      children: [/*#__PURE__*/_jsx("span", {
        children: description
      }), cta && /*#__PURE__*/_jsx(Button, {
        href: cta.url,
        use: "tertiary",
        size: "extra-small",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: cta.message
        })
      })]
    })
  });
};
export default PromotionBanner;